import React from 'react';
import { useGlobalUser, useLoginModal } from '@sparknz/journeys-common';
import {
  ButtonVariant,
  ProductCardButton,
} from '@sparknz/spark-pattern-library';
import { updateTrackedUser } from '@sparknz/tracking';

import { OfferEligibilityLevelType } from '__generated__/MobilePlanCardsProductsQuery.graphql';
import { useSelectedPlans } from 'components/shop/MobilePlans/providers';
import { OfferEligibilityLevelEnum } from 'components/shop/MobilePlans/typings/plans';
import { trackChangePlanEvent } from 'components/shop/MobilePlans/utils/tracking.utils';

interface CheckEligibilityButtonProps {
  categoryIdentifiers?: readonly string[] | null;
  planId: string;
  planName: string;
  offerEligibilityLevel?: OfferEligibilityLevelType | null;
  relatedOfferId?: string | null;
  relatedOfferIds?: readonly string[] | null;
  label?: string;
  variant?: ButtonVariant;
}

export default function CheckEligibilityButton({
  categoryIdentifiers,
  planId,
  planName,
  offerEligibilityLevel = OfferEligibilityLevelEnum.Account,
  relatedOfferId,
  relatedOfferIds,
  label = 'Check eligibility',
  variant = 'primary',
}: Readonly<CheckEligibilityButtonProps>) {
  const { selectIndividualPlan, openSelectedPlansLayer } = useSelectedPlans();
  const { openLoginModal } = useLoginModal();
  const {
    authenticatedInfo: { hasSparkId },
    refetchUser,
  } = useGlobalUser();

  const handleLoginSuccess = async () => {
    updateTrackedUser();
    refetchUser();
    selectIndividualPlan(planId, planName, {
      categoryIdentifiers,
      offerEligibilityLevel,
      isPrimary: false,
      relatedOfferId,
      relatedOfferIds,
      skipGuestLogin: true,
    });
    openSelectedPlansLayer();
  };

  function handleClick() {
    trackChangePlanEvent();
    if (!hasSparkId) {
      openLoginModal({
        onLoginSuccess: handleLoginSuccess,
      });
    } else {
      handleLoginSuccess();
    }
  }

  return (
    <ProductCardButton variant={variant} onClick={handleClick}>
      {label}
    </ProductCardButton>
  );
}
